// Fachada do domínio Webhooks de saída (adapters Supabase → service).
// `notifyWebhook` é o ponto usado pelos fluxos comerciais; o resto é
// configuração (Super Admin).

import { workspaceWebhookService } from './core';

// Disparo fire-and-forget de um evento comercial. Non-fatal por contrato.
export const notifyWebhook = workspaceWebhookService.notify;

// ─── Configuração por workspace (Super Admin) ───────────────────
export const getWorkspaceWebhookConfig    = workspaceWebhookService.getConfig;
export const listWorkspaceWebhookConfigs  = workspaceWebhookService.listConfigs;
export const saveWorkspaceWebhookConfig   = workspaceWebhookService.saveConfig;
export const deleteWorkspaceWebhookConfig = workspaceWebhookService.deleteConfig;
export const listWebhookDeliveries        = workspaceWebhookService.listDeliveries;

export {
  WORKSPACE_WEBHOOK_EVENTS,
  WORKSPACE_WEBHOOK_EVENT_LABELS,
  WORKSPACE_WEBHOOK_EVENT_HINTS,
  defaultWebhookEvents,
  emptyWebhookConfig,
} from '@modules/webhooks';

export type {
  WorkspaceWebhookEvent,
  WorkspaceWebhookConfig,
  WorkspaceWebhookConfigInput,
  WebhookDelivery,
  DispatchWebhookParams,
} from '@modules/webhooks';
